module.exports = __webpack_public_path__ + "img/sub-title2.7f8ae33c.png";